/**
 * Turn API image bytes (Buffer JSON, { data: number[] }, etc.) or plain URLs into a value
 * suitable for <img src>. Browsers do not provide Node's `Buffer`.
 *
 * @param {unknown} imageField
 * @param {string} [mimeType]
 * @returns {string}
 */
export function imageFieldToDataUrl(imageField, mimeType = 'image/jpeg') {
  if (imageField == null) return '';
  if (typeof imageField === 'string') {
    const s = imageField.trim();
    if (!s) return '';
    if (s.startsWith('data:')) return s;
    if (/^https?:\/\//i.test(s) || s.startsWith('/')) return s;
    if (/^[A-Za-z0-9+/=\s]+$/.test(s) && s.length > 80) {
      return `data:${mimeType};base64,${s.replace(/\s/g, '')}`;
    }
    return '';
  }

  let raw = imageField;
  for (let depth = 0; depth < 5 && raw && typeof raw === 'object'; depth += 1) {
    if (raw instanceof Uint8Array || raw instanceof ArrayBuffer) break;
    if (Array.isArray(raw)) break;
    if (raw.type === 'Buffer' && Array.isArray(raw.data)) {
      raw = raw.data;
      break;
    }
    if (Object.prototype.hasOwnProperty.call(raw, 'data') && raw.data !== undefined) {
      raw = raw.data;
      continue;
    }
    break;
  }

  let u8;
  if (raw instanceof Uint8Array) {
    u8 = raw;
  } else if (raw instanceof ArrayBuffer) {
    u8 = new Uint8Array(raw);
  } else if (Array.isArray(raw)) {
    u8 = new Uint8Array(raw);
  } else {
    return '';
  }

  if (!u8.length) return '';

  const chunk = 8192;
  let binary = '';
  for (let i = 0; i < u8.length; i += chunk) {
    binary += String.fromCharCode.apply(null, u8.subarray(i, Math.min(i + chunk, u8.length)));
  }
  return `data:${mimeType};base64,${btoa(binary)}`;
}
